// Any config specific to KENYA?

export default {
  code: 'KEN',
  countryName: 'Kenya',
  googleSiteVerificationCode: [
    '1efNEoUVk26AlIKw4oKqJgmIL663orOlouhD_L8qa1A',
    '3Jlr0EYgjYnaUs0P94kaKnm-JusVkRP_yrDwmec9jfM'
  ],
  countryDomain: 'https://www.carrefour.ke',
  helplineNumber: '800221322',

  latitude: -1.2672236834605626,
  longitude: 36.810586556760555,
  countryFlagIcon: 'KE_87c969bc38.png',
  defaultAreaCode: 'Westlands - Nairobi',
  features: {
    languageChange: false,
    now: false,
    share: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: '06dd9e6f-6fe1-4096-8098-e6e272bb5399'
  }
}
